(function () {
  var STORAGE_KEY = 'rbk-recently-viewed';

  // Same Storefront API token/endpoint card-product.liquid's sibling
  // features (collection-product-swatches.liquid, color-swatch_product.
  // liquid) already use client-side elsewhere in this theme — reused here
  // rather than introduced fresh, since /products/{handle}.js (the REST
  // endpoint this used to call) has no metafields at all. It can't supply
  // the "Gender • Activity" subtitle line, though: custom.gender and
  // custom.reebok_sports both come back null via this API regardless of
  // query shape — neither metafield definition has Storefront API access
  // enabled in Shopify Admin, only Liquid's own unrestricted access
  // (confirmed directly against this store). That subtitle is fetched
  // separately below, via Section Rendering instead.
  var STOREFRONT_TOKEN = 'be6e04d7e507270c678de8f8813b6f95';
  var STOREFRONT_ENDPOINT = '/api/2024-07/graphql.json';

  // '/products/' or '/ar/products/', so card links and the subtitle fetch
  // stay in the shopper's language.
  function productsRoot() {
    var root = ((window.routes && window.routes.root_url) || '/').replace(/\/$/, '');
    return root + '/products/';
  }

  function readHandles() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (err) {
      return [];
    }
  }

  function writeHandles(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (err) {
      // localStorage unavailable (private browsing, quota, disabled) —
      // recently viewed just won't persist; nothing else depends on it.
    }
  }

  // Moves the current handle to the front (or inserts it) rather than
  // appending, so re-visiting a product bumps it back to "most recent"
  // instead of leaving a stale, older entry sitting in the list too.
  function recordView(handle, maxProducts) {
    if (!handle) return;
    var handles = readHandles().filter(function (existing) {
      return existing !== handle;
    });
    handles.unshift(handle);
    if (handles.length > maxProducts) {
      handles = handles.slice(0, maxProducts);
    }
    writeHandles(handles);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  // Builds one <li> the same shape SliderComponent (global.js) expects —
  // [id^="Slide-"], since it re-scopes to that selector whenever this
  // grid's content changes.
  function buildCardHtml(product, slideIndex) {
    // Price markup is rendered by Liquid (snippets/price.liquid, same as the
    // Discover row) via recently-viewed-subtitle.liquid. Left out entirely
    // when missing rather than printing a bare, currency-less number.
    var priceHtml = product.priceHtml
      ? '<span class="recently-viewed-card__price">' + product.priceHtml + '</span>'
      : '';

    var subtitleHtml = '';
    if (product.subtitle) {
      // Same class as card-product.liquid's own subtitle span, reusing
      // its existing typography instead of duplicating it here.
      subtitleHtml =
        '<span class="rbk-card__subtitle caption-large light">' + escapeHtml(product.subtitle) + '</span>';
    }

    return (
      '<li id="Slide-recently-viewed-' +
      slideIndex +
      '" class="grid__item slider__slide">' +
      '<a href="' +
      escapeHtml(product.url) +
      '" class="recently-viewed-card">' +
      '<span class="recently-viewed-card__media">' +
      '<img src="' +
      escapeHtml(product.image) +
      '" alt="' +
      escapeHtml(product.title) +
      '" loading="lazy" class="recently-viewed-card__img">' +
      '</span>' +
      '<span class="recently-viewed-card__title">' +
      escapeHtml(product.title) +
      '</span>' +
      priceHtml +
      subtitleHtml +
      '</a>' +
      '</li>'
    );
  }

  var PRODUCT_QUERY =
    'query RecentlyViewedProduct($handle: String!) {' +
    '  productByHandle(handle: $handle) {' +
    '    title' +
    '    handle' +
    '    featuredImage { url }' +
    '  }' +
    '}';

  function fetchProductData(handle) {
    return fetch(STOREFRONT_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query: PRODUCT_QUERY, variables: { handle: handle } }),
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (json) {
        var p = json && json.data && json.data.productByHandle;
        if (!p) return null;

        return {
          title: p.title,
          url: productsRoot() + p.handle,
          image: p.featuredImage ? p.featuredImage.url : '',
        };
      })
      .catch(function () {
        return null;
      });
  }

  // sections/recently-viewed-subtitle.liquid renders just the "Gender •
  // Activity" line via Liquid, which has full metafield access regardless
  // of Storefront API visibility settings — resolving `product` from the
  // URL path (not a query string) rather than passing the handle as a
  // param, since request.query_string is documented elsewhere in this
  // feature (recently-viewed-products.liquid) as unreliable for a
  // brand-new section even against the live theme.
  function fetchCardExtras(handle) {
    return fetch(productsRoot() + encodeURIComponent(handle) + '?section_id=recently-viewed-subtitle')
      .then(function (res) {
        return res.ok ? res.text() : '';
      })
      .then(function (html) {
        var subtitle = /<div id="RecentlyViewedSubtitle">([^<]*)<\/div>/.exec(html);
        var price = new DOMParser().parseFromString(html, 'text/html').getElementById('RecentlyViewedPrice');
        return {
          subtitle: subtitle ? subtitle[1] : '',
          priceHtml: price ? price.innerHTML.trim() : '',
        };
      })
      .catch(function () {
        return { subtitle: '', priceHtml: '' };
      });
  }

  function fetchProduct(handle) {
    return Promise.all([fetchProductData(handle), fetchCardExtras(handle)]).then(function (results) {
      var product = results[0];
      if (!product) return null;
      product.subtitle = results[1].subtitle;
      product.priceHtml = results[1].priceHtml;
      return product;
    });
  }

  function initRecentlyViewed(root) {
    var currentHandle = root.dataset.currentHandle;
    var maxProducts = parseInt(root.dataset.maxProducts, 10) || 12;
    var slider = root.querySelector('.discover__slider');
    var grid = root.querySelector('.discover__grid');
    if (!slider || !grid) return;

    // Recorded before filtering it back out of what gets displayed below —
    // otherwise this page's own product would never make it into the list
    // shown on the NEXT product page visited.
    recordView(currentHandle, maxProducts);

    var handles = readHandles().filter(function (handle) {
      return handle !== currentHandle;
    });
    if (!handles.length) return;

    Promise.all(handles.map(fetchProduct))
      .then(function (products) {
        var cardsHtml = products
          .filter(Boolean)
          .map(function (product, index) {
            return buildCardHtml(product, index + 1);
          })
          .join('');

        if (!cardsHtml) return;

        grid.innerHTML = cardsHtml;
        slider.hidden = false;
        if (typeof slider.resetPages === 'function') {
          slider.resetPages();
        }
      })
      .catch(function (err) {
        console.error('[recently-viewed] Failed to load recently viewed products:', err);
      });
  }

  document.querySelectorAll('[data-recently-viewed]').forEach(initRecentlyViewed);
})();
